// extracted by mini-css-extract-plugin
module.exports = {"mainBackContent":"dp-jDvYkmrg","mainContent":"dp-nONVDSH2"};